import {
  Job,
  JobStatus,
  JobType,
} from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';

export const FETCH_JOBS_REQUEST = 'FETCH_JOBS_REQUEST';
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILURE = 'FETCH_JOBS_FAILURE';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_STATUS_FILTER = 'SET_STATUS_FILTER';
export const SET_TYPE_FILTER = 'SET_TYPE_FILTER';
export const RESET_JOBS = 'RESET_JOBS';
export const REQUEST_REFRESH = 'REQUEST_REFRESH';
export const DO_REFRESH = 'DO_REFRESH';
export const SET_SELECTED_JOB = 'SET_SELECTED_JOB';

export const setStatusFilter = (status: JobStatus | null) => ({
  type: SET_STATUS_FILTER,
  payload: status,
});

export const setTypeFilter = (type: JobType | null) => ({
  type: SET_TYPE_FILTER,
  payload: type,
});

export const setCurrentPage = (page: number) => ({
  type: SET_CURRENT_PAGE,
  payload: page,
});

export const resetJobs = () => ({
  type: RESET_JOBS,
});

export const refreshJobs = () => ({
  type: DO_REFRESH,
});

export const requestRefresh = (refresh: boolean) => ({
  type: REQUEST_REFRESH,
  payload: refresh,
});

export const setSelectedJob = (job: Job<any> | null) => ({
  type: SET_SELECTED_JOB,
  payload: job,
});
